export default __webpack_public_path__ + "ddd8c2a1bbb1fafa96ac3218c081c131.jpg";